import Joi from "joi";

const schema = Joi.object({
  firstName: Joi.string()
    .pattern(/.*\S.*/)
    .trim()
    .required(),
  lastName: Joi.string()
    .pattern(/.*\S.*/)
    .trim()
    .required(),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
  password: Joi.string().min(6).required(),
});

export default schema;
